import { useEffect } from "react";
import { QueryProvider } from "./components/providers/QueryProvider";
import { MotionConfig } from "motion/react";
import { animationCurves } from "./utils/animationCurves";
import { HelmetProvider } from "react-helmet-async";
import { Router } from "./components/shared/Router";
import { ContentfulClientProvider } from "./components/providers/ContentfulClientProvider";
import { ThemeContextProvider } from "./components/providers/ThemeContextProvider";
import { GlobalContext, GlobalContextType } from "./utils/GlobalContext";
import { loadGoogleAnalytics } from "./utils/gTagLoader";
import { loadOneTrustConsent } from "./utils/oneTrustLoader";

export const App = ({
  globalContext,
}: {
  globalContext: GlobalContextType;
}) => {
  const { region, environment } = globalContext;

  useEffect(() => {
      loadGoogleAnalytics();
  }, [region]);

  useEffect(() => {
    loadOneTrustConsent(environment);
  }, [environment]);

  return (
    
    <GlobalContext.Provider value={globalContext}>
      <QueryProvider>
        <HelmetProvider>
          <MotionConfig transition={animationCurves.default}>
            <ContentfulClientProvider>
              <ThemeContextProvider root>
                <Router />
              </ThemeContextProvider>
            </ContentfulClientProvider>
          </MotionConfig>
        </HelmetProvider>
      </QueryProvider>
    </GlobalContext.Provider>
  );
};
